<span class="spinner" [class.spinner--inline]="inline"
      [ngClass]="{'layout-mask': !inline, 'modal-in': !inline && overlay}"
      role="status" [attr.aria-label]="'common.loading' | translate">
  <span class="app-loading-ring" [class.app-loading-ring--multicolor]="multicolor"
        [style.--app-spinner-size]="size" aria-hidden="true"></span>
</span>
